import { Descriptions, Divider, Drawer, Space, Image } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { RevxButton } from 'components/RevxButton';
import RevxTable, { TableColumnsType } from 'components/RevxTable';
import { SvcSpec } from 'domains/svcDomain';
import { isEmpty, isUndefined } from 'lodash-es';
import { useTranslation } from 'react-i18next';
import { UPLOAD_FILE_ADDRESS_PREFIX } from 'utils/constants';
import { SVCBaseTable } from './SVCBaseTable';

export const SVCBaseSelect = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { visible, curItem } = useAppSelector(
    (state) => state.svc.baseSelectState
  );
  const onCancel = () => {
    dispatch.svc.updateBaseSelectItem(undefined);
  };
  const onClose = () => {
    dispatch.svc.updateBaseSelectItem(undefined);
    dispatch.svc.updateBaseSelectVisible(false);
  };
  const onSave = () => {
    if (isUndefined(curItem)) return;
    dispatch.svc.createOrgSvc(curItem.id);
    onClose();
  };

  const specColumns: TableColumnsType<SvcSpec> = [
    {
      title: t('common.revxId'),
      dataIndex: 'revxId',
      width: 80,
    },
    {
      title: t('common.description'),
      dataIndex: 'description',
      width: 80,
    },
    {
      title: t('platform.svc.tableColumn.costUsd'),
      width: 80,
      dataIndex: 'costUsd',
      valueType: 'money',
      decimalDigits: 4,
      responsive: ['xl'],
    },
    {
      title: t('platform.svc.tableColumn.makereadyCost'),
      width: 80,
      dataIndex: 'makereadyCostUsd',
      valueType: 'money',
      decimalDigits: 2,
      responsive: ['xl'],
    },
  ];

  return (
    <Drawer
      title={t('platform.svc.form.title.orgCreate')}
      placement="right"
      width={800}
      bodyStyle={{ paddingTop: 0 }}
      closable={true}
      onClose={onClose}
      visible={visible}
    >
      <SVCBaseTable />

      {Boolean(curItem) && (
        <>
          <Divider orientation="left">
            {t('platform.svc.baseSelect.selectedDescTitle')}
          </Divider>
          <Descriptions
            bordered
            size="small"
            extra={[
              <Space key="space">
                <RevxButton key="save" type="primary" onClick={onSave}>
                  {t('common.save')}
                </RevxButton>
                <RevxButton onClick={onCancel}>{t('common.cancel')}</RevxButton>
              </Space>,
            ]}
          >
            <Descriptions.Item label={t('common.revxId')}>
              {curItem?.revxId}
            </Descriptions.Item>
            <Descriptions.Item label={t('common.name')}>
              {curItem?.name}
            </Descriptions.Item>
            <Descriptions.Item label={t('platform.svc.form.image')}>
              {isEmpty(curItem?.image) ? (
                <></>
              ) : (
                <Image
                  width={24}
                  src={UPLOAD_FILE_ADDRESS_PREFIX + curItem?.image}
                />
              )}
            </Descriptions.Item>
          </Descriptions>
          <RevxTable<SvcSpec>
            title={() => 'Specs'}
            size="small"
            pagination={false}
            columns={[...specColumns]}
            scroll={undefined}
            dataSource={curItem?.svcSpecs}
            rowKey={(record) => 'spec' + record.id}
          />
        </>
      )}
    </Drawer>
  );
};
